import React from 'react';
import { Grid, Row } from "react-bootstrap";
import { Card } from 'components/Card/Card.jsx';
import Cookies from 'universal-cookie';
import cookieManagement from '../utilities/Cookie';
import { FetchAPI } from 'api/fetch';
const cookies = new Cookies();
let logoName = cookies.get('clientSubDomain') == undefined ? cookieManagement.setClientSubDomainToCookie() : cookies.get('clientSubDomain');

const Wallet = props => {

   async function qrcodeValue() {
        let URL = "https://staging.esealcom.com:3003/scan-qrcode";
        let res = await FetchAPI(URL);
        console.log("**RESS", res);
    }

    const WalletCards = ({ logoName, walletData }) => {
        return (<Grid fluid>
            <Row>
                <Card style={{ fontSize: '12px' }}
                    title="eSeal"
                    title2="POC"
                    content={
                        <div>
                            <div className="row">
                                <div className="col-md-4 col-md-offset-4">
                                    <Card
                                        stats={"Eseal QR Code with dynamic call to action (SCAN THIS QR WITH YOUR MOBILE PHONE)"}
                                        statsIcon="fa fa-qrcode"
                                        content={
                                            <div
                                                style={{
                                                    position: 'relative',
                                                    overflow: 'hidden',
                                                    fontSize: '45px'
                                                }}
                                            >
                                                <div className="col-md-12 text-center">
                                                    <img width="50%" src="images/qr-code.png" />
                                                </div>
                                            </div>
                                        }
                                    />
                                </div>
                            </div>

                            {/* <div className="row">
                                <div className="col-md-4 col-md-offset-4">
                                        <Card
                                            stats={"This gives you an idea of scanning done via Eseal Mobile Application for the same QR Code as above"}
                                            statsIcon="fa fa-qrcode"
                                            content={
                                                <div
                                                    style={{
                                                        position: 'relative',
                                                        overflow: 'hidden',
                                                        fontSize: '45px'
                                                    }}
                                                >
                                                    <div className="col-md-12 text-center">
                                                        <div className="d-grid gap-2">
                                                            <a target="_blank" href="/product-detail">
                                                                <Button onClick={qrcodeValue} variant="primary" size="lg">
                                                                    Click here to view Eseal App Demo/Product Details Page
                                                                </Button>
                                                            </a>
                                                        </div>
                                                    </div>
                                                </div>
                                            }
                                        />
                                    </div>
                            </div> */}
                        </div>
                    }
                >
                </Card>
            </Row>
        </Grid>);
    };

    return (
            <div className="content">
                <WalletCards
                    logoName={logoName}
                    walletData={"walletVal"}
                />
            </div>
    );
}

export default Wallet;
